import { SvgIcon, SvgIconProps } from "@mui/material";
import { forwardRef } from "react";

export default forwardRef<SVGSVGElement, SvgIconProps>(function CollapseIcon(
  props: SvgIconProps,
  ref,
) {
  return (
    <SvgIcon
      ref={ref}
      {...props}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M18 9H15.42L18.71 5.71C18.8983 5.5217 19.0041 5.2663 19.0041 5C19.0041 4.7337 18.8983 4.47831 18.71 4.29C18.5217 4.1017 18.2663 3.99591 18 3.99591C17.7337 3.99591 17.4783 4.1017 17.29 4.29L14 7.57V5C14 4.73479 13.8946 4.48043 13.7071 4.2929C13.5196 4.10536 13.2652 4 13 4C12.7348 4 12.4804 4.10536 12.2929 4.2929C12.1054 4.48043 12 4.73479 12 5V10C12 10.2652 12.1054 10.5196 12.2929 10.7071C12.4804 10.8946 12.7348 11 13 11H18C18.2652 11 18.5196 10.8946 18.7071 10.7071C18.8946 10.5196 19 10.2652 19 10C19 9.73479 18.8946 9.48043 18.7071 9.2929C18.5196 9.10536 18.2652 9 18 9Z'
        fill='currentColor'
      />
      <path
        d='M8.99994 13H3.99994C3.73472 13 3.48037 13.1054 3.29283 13.2929C3.1053 13.4804 2.99994 13.7348 2.99994 14C2.99994 14.2652 3.1053 14.5196 3.29283 14.7071C3.48037 14.8946 3.73472 15 3.99994 15H6.56994L3.28994 18.29C3.19621 18.383 3.12182 18.4936 3.07105 18.6154C3.02028 18.7373 2.99414 18.868 2.99414 19C2.99414 19.132 3.02028 19.2627 3.07105 19.3846C3.12182 19.5064 3.19621 19.617 3.28994 19.71C3.3829 19.8037 3.4935 19.8781 3.61536 19.9289C3.73722 19.9797 3.86793 20.0058 3.99994 20.0058C4.13195 20.0058 4.26266 19.9797 4.38452 19.9289C4.50638 19.8781 4.61698 19.8037 4.70994 19.71L7.99994 16.42V19C7.99994 19.2652 8.1053 19.5196 8.29283 19.7071C8.48037 19.8946 8.73472 20 8.99994 20C9.26516 20 9.51951 19.8946 9.70705 19.7071C9.89458 19.5196 9.99994 19.2652 9.99994 19V14C9.99994 13.7348 9.89458 13.4804 9.70705 13.2929C9.51951 13.1054 9.26516 13 8.99994 13Z'
        fill='currentColor'
      />
    </SvgIcon>
  );
});
